import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-yhm",
  "use": "icon-yhm-usage",
  "viewBox": "0 0 11 12.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 12.6\" id=\"icon-yhm\">\r\n    <title>资源 1</title>\r\n    <g id=\"icon-yhm_图层_2\" data-name=\"图层 2\">\r\n        <g id=\"icon-yhm_图层_1-2\" data-name=\"图层 1\">\r\n            <path d=\"M5.5,7.6A3.8,3.8,0,1,1,9.3,3.8,3.8,3.8,0,0,1,5.5,7.6ZM5.5,1A2.9,2.9,0,0,0,2.7,3.8,2.9,2.9,0,0,0,5.5,6.6,2.9,2.9,0,0,0,8.3,3.8,2.9,2.9,0,0,0,5.5,1Z\" />\r\n            <path d=\"M10.5,12.6a.5.5,0,0,1-.5-.5,4.5,4.5,0,0,0-9,0,.5.5,0,0,1-.5.5.5.5,0,0,1-.5-.5A5.5,5.5,0,0,1,5.5,6.6,5.5,5.5,0,0,1,11,12.1.5.5,0,0,1,10.5,12.6Z\" />\r\n        </g>\r\n    </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/yhm.svg
// module id = czHC
// module chunks = 72